module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-marriage-certificate-1dd797c790831d5f71dfd040051622f1.png";